var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row",class:_vm.calcRowClass},[_c('h5',{staticClass:"col-auto mx-auto"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }